module.exports = __webpack_public_path__ + "static/media/prism UI v3.254cc867.sketch";